import { apiPost } from '@/utils/request'

//登录接口
export function fnLogin(data: object) {
    return apiPost('/api/user/login', data)
}

//注册接口
export function fnRegister(data: object) {
    return apiPost('/api/user/register', data)
}